export default "__VITE_ASSET__ZLqlZkBx__"